
import React from 'react';
import { Link } from 'react-router-dom';

interface CustomBusinessFooterProps {
  terms?: string;
  privacy?: string;
  contactEmail?: string;
}

const CustomBusinessFooter: React.FC<CustomBusinessFooterProps> = ({
  terms,
  privacy,
  contactEmail
}) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 py-8 mt-auto border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-3">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-gray-600 hover:text-gray-900 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-600 hover:text-gray-900 transition-colors">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-gray-900 transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-3">Contact</h3>
            {contactEmail && (
              <a 
                href={`mailto:${contactEmail}`} 
                className="text-gray-600 hover:text-gray-900 transition-colors"
              >
                {contactEmail}
              </a>
            )}
          </div>
        </div>
        
        <hr className="my-6 border-gray-300" />
        
        <div className="text-center text-gray-600">
          <p>&copy; {currentYear} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default CustomBusinessFooter;
